// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlWriteResult
 */
export interface ControlWriteResult {
    /**
     * 
     * @type {string}
     * @memberof ControlWriteResult
     */
    browsePath?: string;
    /**
     * The value that was written
     * @type {any}
     * @memberof ControlWriteResult
     */
    value?: any | null;
}

/**
 * Check if a given object implements the ControlWriteResult interface.
 */
export function instanceOfControlWriteResult(value: object): value is ControlWriteResult {
    return true;
}

export function ControlWriteResultFromJSON(json: any): ControlWriteResult {
    return ControlWriteResultFromJSONTyped(json, false);
}

export function ControlWriteResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlWriteResult {
    if (json == null) {
        return json;
    }
    return {
        
        'browsePath': json['browsePath'] == null ? undefined : json['browsePath'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function ControlWriteResultToJSON(json: any): ControlWriteResult {
    return ControlWriteResultToJSONTyped(json, false);
}

export function ControlWriteResultToJSONTyped(value?: ControlWriteResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browsePath': value['browsePath'],
        'value': value['value'],
    };
}

